import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, className = "", delay = 0, y = 28, once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, amount: 0.2 }}
    transition={{ duration: 0.8, ease, delay }}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", mountAnimate = false }) => (
  <motion.div
    className={className}
    initial="hidden"
    {...(mountAnimate
      ? { animate: "show" }
      : { whileInView: "show", viewport: { once: true, amount: 0.15 } })}
    variants={{ hidden: {}, show: { transition: { staggerChildren: 0.09 } } }}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className = "", y = 28 }) => (
  <motion.div
    className={className}
    variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease } } }}
  >
    {children}
  </motion.div>
);

/* Gold hand-drawn marker highlight under a word */
export const Marker = ({ children, color = "#E7C579" }) => (
  <span className="marker">
    {children}
    <svg viewBox="0 0 300 24" preserveAspectRatio="none" aria-hidden="true">
      <motion.path
        d="M4 16 C60 8 120 6 180 9 C230 11 270 13 296 10"
        stroke={color}
        strokeWidth="12"
        strokeLinecap="round"
        fill="none"
        initial={{ pathLength: 0, opacity: 0 }}
        whileInView={{ pathLength: 1, opacity: 0.7 }}
        viewport={{ once: true }}
        transition={{ duration: 1, ease, delay: 0.5 }}
      />
    </svg>
  </span>
);

export const SectionHead = ({ eyebrow, title, sub, align = "left", light = false }) => (
  <div className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <span className="eyebrow">{eyebrow}</span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`mt-5 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl ${light ? "text-white" : "text-navy"}`}>
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className={`mt-5 text-base leading-relaxed ${light ? "text-white/70" : "text-muted"}`}>{sub}</p>
      </Reveal>
    )}
  </div>
);
